import { providerSubscriptionMetadataSchema } from '@inkitt/contracts-common';
import { z } from 'zod';

export const gtvSubscriptionMetadataSchema = providerSubscriptionMetadataSchema.and(
  z.object({
    product: z.literal('galateatvEarlyAccess'),
  }),
);

export type GtvSubscriptionMetadata = z.infer<typeof gtvSubscriptionMetadataSchema>;

const EARLY_ACCESS_WEEKLY_SUBSCRIPTION_METADATA = gtvSubscriptionMetadataSchema.parse({
  product: 'galateatvEarlyAccess',
  entitlement: 'gtv_early_access',
  family: 'early_access',
  billingPeriod: 'weekly',
});

export const subscriptionMetadataByProductIdLookup: Readonly<Record<string, GtvSubscriptionMetadata>> = {
  'com.galateatv.early_access.p1w': EARLY_ACCESS_WEEKLY_SUBSCRIPTION_METADATA,
  'com.galateatv.early_access.intro.p1w': EARLY_ACCESS_WEEKLY_SUBSCRIPTION_METADATA,
  'com.galateatv.early_access:p1w': EARLY_ACCESS_WEEKLY_SUBSCRIPTION_METADATA,
};

export const getGtvSubscriptionMetadataByProductId = (productId: string): GtvSubscriptionMetadata | null =>
  subscriptionMetadataByProductIdLookup[productId] ?? null;

export const doesGtvProductIdMatchEntitlement = (productId: string, entitlementName: string): boolean =>
  getGtvSubscriptionMetadataByProductId(productId)?.entitlement === entitlementName;

export const isGtvEarlyAccessProductId = (productId: string): boolean =>
  productId.startsWith('com.galateatv.early_access');
